import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Menu, Switch, Spin, Col, Row, Modal } from "antd";
import { Link, useHistory } from "react-router-dom";
import Replace2x from '../../util/Extensions/ReplaceExtension'
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
} from "../../constants/ThemeSetting";

import RequestHandler from "util/RequestHandler";

const SubMenu = Menu.SubMenu;

const HorizontalNav = () => {
  const history = useHistory();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleSms, setIsModalVisibleSms] = useState(false);
  const [
    isModalNotificationsVisible,
    setIsModalNotificationsVisible,
  ] = useState(false);
  const [isLiveValue, setIsLiveValue] = useState(false);
  const [isSmsAccess, setIsSmsAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const [permissions, setPermissions] = useState({
    loading: true,
    modules: [],
    isAdmin: false,
    isGroupAdmin: false,
    isGroupUser: false,
  });
  useEffect(() => {
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      setPermissions({
        ...response,
        loading: false,
      });
    });
  }, []);
  const showModal = () => {
    setLoading(true);
    RequestHandler.get("/TenantCurrency/GetIsDailyValue").then((response) => {
      setIsLiveValue(response.isLiveValue);
      setIsModalVisible(true);
    });
    setLoading(false);
  };
  const showModalSms = () => {
    setLoading(true);
    RequestHandler.get( "/Tenant/GetById/"+Replace2x(localStorage.getItem("tenantId"))).then((response) => {
      setIsSmsAccess(response.isSmsAccess);
      setIsModalVisibleSms(true);
    });
    setLoading(false);
  };
  const showModalNotifications = () => {
    setLoading(true);
    setIsModalNotificationsVisible(true);
  };
  function onChange(checked) {
    RequestHandler.put(
      "/TenantCurrency/PutIsLiveValue",
      {
        isLiveValue: checked,
      },
      true
    ).then((res) => {
      setIsLiveValue(res.data.isLiveValue);
    });
    setTimeout(() => {
      setIsModalVisible(false);
      window.location.reload();
    }, 500);
  }
  function onChangeSms(checked) {
    RequestHandler.post(
      "/Tenant/AllTenantUpdateForSms",
      {
        UserId: Replace2x(localStorage.getItem("userId")),
        IsSmsAccess : checked,
      },
      true
    ).then((res) => {
      setIsSmsAccess(!isSmsAccess)
      window.location.reload();
    });
    setTimeout(() => {
      setIsModalVisible(false);
    }, 500);
  }
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleOkSms = () => {
    setIsModalVisibleSms(false);
  };

  const handleCancelSms = () => {
    setIsModalVisibleSms(false);
  };

  const renderMenuItem = (menuItem) => {
    if (
      menuItem.isRender === false ||
      (menuItem.module && !permissions.modules.includes(menuItem.module))
    )
      return null;

    if (menuItem.children) {
      return (
        <SubMenu
          key={menuItem.key}
          title={
            <span>
              <i className={menuItem.icon} />
              <span>{menuItem.title}</span>
            </span>
          }
        >
          {menuItem.children.map((childItem) => renderMenuItem(childItem))}
        </SubMenu>
      );
    } else {
      return menuItem.key === "currency-live" ? (
        <Menu.Item key={menuItem.key} onClick={() => showModal()}>
          <Link>
            <i className={menuItem.icon} />
            <span>{menuItem.title} </span>
          </Link>
        </Menu.Item>
      ) :(menuItem.key === "password-access" ? 
        <Menu.Item key={menuItem.key} onClick={() => showModalSms()}>
        <Link>
          <i className={menuItem.icon} />
          <span >{menuItem.title} </span>
        </Link>
      </Menu.Item>
      :(
        <Menu.Item
          key={menuItem.key}
          onClick={() => history.push(menuItem.url)}
        >
          <Link to={menuItem.url} style={menuItem.style}>
            <i className={menuItem.icon} />
            <span >{menuItem.title}</span>
          </Link>
        </Menu.Item>
      ));
    }
  };
  const pathname = useSelector(({ settings }) => settings.pathname);

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];
  const menuItems = [
    {
      key: "home",
      url: "/home",
      // icon: "icon icon-home",
      title: "Anasayfa",
      style: { color: "white" },
    },
    {
      key: "accountTransaction",
      url: "/account-transaction",
      // icon: "icon icon-home",
      title: "Hesap Hareketleri",
      style: { color: "white" },
    },
    {
      key: "accountBalance",
      url: "/account-balance",
      // icon: "icon icon-home",
      title: "Hesap Bakiyesi",
      style: { color: "white" },
    },{
      key: "report",
      url: "/report",
      // icon: "icon icon-home",
      title: "Rapor",
      style: { color: "white" },
    },
    // {
    //   key: "accountprocess",
    //   // icon: "icon icon-card",
    //   title: "Hesap İşlemleri",
    //   module: 9,
    //   children: [
    //     {
    //       key: "bank-list",
    //       url: "/bank-list",
    //       icon: "icon icon-all-contacts",
    //       title: "Banka Bakiyeleri",
    //     },
    //     {
    //       key: "bank-accounts",
    //       url: "/bank-accounts",
    //       icon: "icon icon-cards-list-view",
    //       title: "Hesap Bakiyeleri",
    //     },
    //     {
    //       key: "account-transaction",
    //       url: "/account-transaction",
    //       icon: "icon icon-select",
    //       title: "Hesap Hareketleri",
    //     },
    //   ],
    // },
    // {
    //   key: "posOperations",
    //   // icon: "icon icon-revenue-new",
    //   title: "POS Rapor",
    //   module: 5,
    //   children: [
    //     {
    //       key: "pos-transaction",
    //       url: "/pos-transaction",
    //       icon: "icon icon-all-contacts",
    //       title: "POS Hareketleri",
    //     },
    //     {
    //       key: "value-report",
    //       url: "/value-report",
    //       icon: "icon icon-all-contacts",
    //       title: "Valör Raporu",
    //     },
    //     {
    //       key: "commission-report",
    //       url: "/commission-report",
    //       icon: "icon icon-all-contacts",
    //       title: "Komisyon Raporu",
    //     },
    //     {
    //       key: "pos-volume-report",
    //       url: "/pos-volume-report",
    //       icon: "icon icon-all-contacts",
    //       title: "Ciro Raporu",
    //     },
    //   ],
    // },
    // {
    //   key: "tos",
    //   // icon: "icon icon-revenue-new",
    //   title: "TÖS",
    //   module: 2,
    //   children: [
    //     {
    //       key: "tos-payment",
    //       url: "/tos-payment",
    //       icon: "icon icon-ckeditor",
    //       title: "Ödeme Listesi",
    //     },
    //     {
    //       key: "tos-order",
    //       url: "/tos-order",
    //       icon: "icon icon-editor",
    //       title: "Talimat Listesi",
    //     },
    //     {
    //       key: "tos-sent-payment",
    //       url: "/tos-sent-payment",
    //       icon: "icon icon-sent",
    //       title: "Gönderilmiş Ödemeler",
    //     },
    //   ],
    // },
    // {
    //   key: "dbs",
    //   // icon: "icon icon-revenue-new",
    //   title: "DBS",
    //   module: 3,
    //   children: [
    //     {
    //       key: "dbs-dealer",
    //       url: "/dbs-dealer",
    //       icon: "icon icon-team",
    //       title: "Bayi Bilgileri",
    //     },
    //     {
    //       key: "dbs-invoice",
    //       url: "/dbs-invoice",
    //       icon: "icon icon-editor",
    //       title: "Fatura Listesi",
    //     },
    //     {
    //       key: "dbs-sent-invoice",
    //       url: "/dbs-sent-invoice",
    //       icon: "icon icon-sent",
    //       title: "Gönderilmiş Faturalar",
    //     },
    //   ],
    // },
    // {
    //   key: "reports",
    //   // icon: "icon icon-amchart",
    //   title: "Raporlar",
    //   children: [
    //     {
    //       key: "firm-status-report",
    //       url: "/firm-status-report",
    //       icon: "icon icon-company",
    //       title: "Cari Durumları",
    //     },
    //     {
    //       key: "chart-reports",
    //       url: "/chart-reports",
    //       icon: "icon icon-company",
    //       title: "Ay Bazlı Grafik",
    //     },
    //     {
    //       key: "monthly-firm-status-report",
    //       url: "/monthly-firm-status-report",
    //       icon: "icon icon-company",
    //       title: "Tarih Bazlı Durum",
    //     },
    //     {
    //       key: "consolidated-bank",
    //       url: "/consolidated-bank",
    //       icon: "icon icon-all-contacts",
    //       title: "Konsolide Banka",
    //       isRender: permissions.isGroupUser,
    //     },
    //   ],
    // },
    // {
    //   key: "firmtype",
    //   // icon: "icon icon-company",
    //   title: "Cariler ve Planlar",
    //   children: [
    //     {
    //       key: "firms",
    //       // icon: "icon icon-company",
    //       title: "Cari İşlemleri",
    //       children: [
    //         {
    //           key: "firm-list",
    //           url: "/firm-list",
    //           icon: "icon icon-all-contacts",
    //           title: "Cari Listesi",
    //         },
    //         {
    //           key: "firm-account-list",
    //           url: "/firm-account-list",
    //           icon: "icon icon-anchor",
    //           title: "Cari Hesapları",
    //         },
    //       ],
    //     },
    //     {
    //       key: "plans",
    //       // icon: "icon icon-company",
    //       title: "Plan-Elden İşlem",
    //       children: [
    //         {
    //           key: "monthly-plan-list",
    //           url: "/monthly-plan-list",
    //           icon: "icon icon-all-contacts",
    //           title: "Ödeme-Tahsilat Planları",
    //         },
    //         {
    //           key: "manual-account-transaction",
    //           url: "/manual-account-transaction",
    //           icon: "icon icon-data-entry",
    //           title: "Elden İşlem",
    //         },{
    //           key: "erp-activity-list",
    //           url: "/erp-activity-list",
    //           icon: "icon icon-data-entry",
    //           title: "Veri Yükleme",
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   key: "erp",
    //   title: "Erp",
    //   module: 7,
    //   children: [
    //     {
    //       key: "erp-incoming-transaction",
    //       url: "/erp-incoming-transaction",
    //       icon: "icon icon-chart-line",
    //       title: "Gelen İşlemler",
    //     },
    //     {
    //       key: "erp-outgoing-transaction",
    //       url: "/erp-outgoing-transaction",
    //       icon: "icon icon-chart-area-new",
    //       title: "Giden İşlemler",
    //     },
    //     {
    //       key: "erp-report",
    //       icon: "icon icon-pricing-table",
    //       title: "Erp Rapor",
    //       children: [
    //         {
    //           key: "erp-firm-report",
    //           url: "/erp-firm-report",
    //           icon: "icon icon-all-contacts",
    //           title: "Cari Takip",
    //         },
    //         {
    //           key: "erp-stock-report",
    //           url: "/erp-stock-report",
    //           icon: "icon icon-all-contacts",
    //           title: "Stok Durumu",
    //         },
    //       ],
    //     },
    //   ],
    // },
     {
       key: "setting",
        // icon: "icon icon-setting",
       title: "Ayarlar",
       isRender: permissions.isAdmin,
       children: [
        //  {
        //    key: "group-list",
        //    url: "/group-list",
        //    icon: "icon icon-company",
        //    title: "Grup Yönetimi",
        //    isRender: permissions.isGroupAdmin,
        //  },
        //  {
        //    key: "transaction-bank-info",
        //    url: "/transaction-bank-info",
        //    icon: "icon icon-all-contacts",
        //    title: "Hesap Erişimi",
        //  },
        //  {
        //    key: "currency-live",
        //    url: "",
        //    icon: "icon icon-cards-list-view",
        //    title: "Döviz Kuru",
        //  }, {
        //    key: "password-access",
        //    url: "",
        //    icon: "icon icon-cards-list-view",
        //    title: "Şifre Onay",
        //  },
        //  {
        //    key: "notifications",
        //    url: "/notifications",
        //    icon: "icon icon-cards-list-view",
        //    title: "Bildirim",
        //  },
         {
           key: "user-list",
           url: "/user-list",
           icon: "icon icon-all-contacts",
           title: "Kullanıcı Listesi",
         },]},
    //     {
    //       key: "firm-user",
    //       url: "/firm-user",
    //       icon: "icon icon-contacts",
    //       title: "Firma Paneli",
    //       module: 8,
    //     },
    //     {
    //       key: "types",
    //       // icon: "icon icon-setting",
    //       title: "İşlem Tipleri",
    //       children: [
    //         {
    //           key: "firm-class-list",
    //           url: "/firm-class-list",
    //           icon: "icon icon-menu-unfold",
    //           title: "Cari Sınıfları",
    //         },
    //         {
    //           key: "monthly-plan-type-list",
    //           url: "/monthly-plan-type-list",
    //           icon: "icon icon-home",
    //           title: "Aylık Plan Tipleri",
    //         },
    //         {
    //           key: "manual-account-transaction-type",
    //           url: "/manual-account-transaction-type",
    //           icon: "icon icon-data-entry",
    //           title: "Elden İşlem Tipi",
    //         },
    //       ],
    //     },
    //   ],
    // },
  ];
  return (
    <Menu
      defaultOpenKeys={[defaultOpenKeys]}
      selectedKeys={[selectedKeys]}
      mode="horizontal"
      style={{ backgroundColor: "transparent" }}
    >
      {permissions.loading
        ? null
        : menuItems.map((menuItem) => {
            return renderMenuItem(menuItem);
          })}
      <Modal
        title="Döviz Kurları"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
      >
        <Spin spinning={loading}>
          <Row>
            <Col span={2}></Col>
            <Col span={6}>Günlük Veri</Col>
            <Col span={2}>
              <Switch defaultChecked={isLiveValue} onChange={onChange} />
            </Col>
            <Col span={2}></Col>
            <Col span={6}>Anlık Veri </Col>
            <Col span={5}> </Col>
          </Row>
        </Spin>
      </Modal>
      <Modal
        title="Sms Onayı"
        visible={isModalVisibleSms}
        onOk={handleOkSms}
        onCancel={handleCancelSms}
        footer={false}
      >
        <Spin spinning={loading}>
          <Row>
            <Col span={2}></Col>
            <Col span={6}>Şifresiz Giriş</Col>
            <Col span={2}>
              <Switch defaultChecked={isSmsAccess} onChange={onChangeSms}/>
            </Col>
            <Col span={2}></Col>
            <Col span={6}>Şifreli Giriş </Col>
            <Col span={5}> </Col>
          </Row>
        </Spin>
      </Modal>
    </Menu>
  );
};

HorizontalNav.propTypes = {};

export default HorizontalNav;
